<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <!-- <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div> -->
        <div class="logo">
            <img src="../../assets/img/logo.png" alt="logo">
        </div>
        <div class="header-right">
            <div class="header-user-con" style="font-size: 14px;">
                <!-- 全屏显示 -->
                <!-- <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div> -->
                <!-- 消息中心 -->
            <!--    <div class="btn-bell">
                    <el-tooltip
                        effect="dark"
                        :content="message?`有${message}条未读消息`:`消息中心`"
                        placement="bottom"
                    >
                        <router-link to="/tabs">
                            <i class="el-icon-bell"></i>
                        </router-link>
                    </el-tooltip>
                    <span class="btn-bell-badge" v-if="message"></span>
                </div> -->
                <!-- 用户头像 -->
               <!-- <div class="user-avator">
                    <img src="../../assets/img/img.jpg" />
                </div> -->
                <div style="padding-right: 30px;" v-if="currUserData.userType != '0'">
                    当前集团：{{ currUserData.companyGroupName }}
                </div>
                <div style="padding-right: 30px;" v-if="currUserData.userType != '0'">
                    <el-badge :value="checkCompanyCount">
                        <el-link :underline="false" style="color: #fff;" @click="checkComanyClickFun()">勾选实体</el-link>
                    </el-badge>
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ currUserData.userName }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <a href="https://github.com/lin-xin/vue-manage-system" target="_blank">
                            <el-dropdown-item>项目仓库</el-dropdown-item>
                        </a> -->
                        <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dialog title="勾选实体" :visible.sync="checkCompanyDialogVisible" width="40%" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-table ref="checkCompanyTable" :data="checkCompanyTableData" height="400px" border stripe class="table" @row-click="clickRowByChecked">
                    <el-table-column type="selection" width="50"></el-table-column>
                    <el-table-column prop="id" v-if="showColumn == true"></el-table-column>
                    <el-table-column prop="name" label="实体名称" align="center"></el-table-column>
                    <el-table-column prop="taxNumber" label="实体税号" sortable align="center"></el-table-column>
                    <el-table-column prop="state" label="当前状态" sortable :formatter="formatStatus" align="center"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveCheckCompanyClickFun()" style="width: 80px;">保存</el-button>
                <el-button @click="checkCompanyDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import bus from '../common/bus';
import https, { fetchGet,fetchPost } from '../../../https.js';true
export default {
    data() {
        return {
            collapse: true,
            fullscreen: false,
            name: 'linxin',
            message: 2,
            groupName: '',
            userName: '',
            showColumn: false,
            checkCompanyDialogVisible: false,
            checkCompanyTableData: [],
            checkCompanyCount: 0,   //  勾选实体数量
            checkCompanyList: [],   //  当前用户已勾选实体信息
            currUserData: {}   //  当前用户信息
        };
    },
    created: function() {
        this.getCurrentUserList().then(currUserData => {
            if(currUserData != null) {
                this.currUserData = currUserData;
            } 
        });
        //  获取当前用户已勾选的公司信息
        this.getCheckCompanyData();
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {    //  退出登录
				fetchGet('/login/getPortal', {}).then(res => {
					let token = localStorage.getItem('token');
					if(res.data.code=='200' && res.data.enable == '1' && localStorage.getItem('portalLogin') == 'true'){
						localStorage.clear();
						window.location.href = res.data.url+"?token="+token;
					}else{
						localStorage.clear();
						fetchPost('/login/loginout', token).then(res => {
						    if(res.data.success) {
						        // localStorage.removeItem('token');
						        this.$router.push('/login');
						    } else {
						        this.$message.info('注销成功！');
						        this.$router.push('/login');
						    }
						}).catch(error => {
						    this.$message.error(error);
						});
					}
				}); 
            }
        },
        async clickRowByChecked(row) {
            this.$refs.checkCompanyTable.toggleRowSelection(row);
        },
        async getCheckCompanyData() {   //  获取当前用户已勾选的公司信息
            this.getUserCheckCompanyList().then(userCheckCompanyList => {
                this.checkCompanyCount = userCheckCompanyList.length;
                this.checkCompanyList = userCheckCompanyList;
            });
        },
        async loadCheckCompanyData() {
            this.getCheckCompanyData().then(res => {
                this.getUserBeLongsCompanyList().then(userRelCompanyList => {
                    this.checkCompanyTableData = userRelCompanyList;

                    this.filterCheckCompanyList(userRelCompanyList).then(checkCompanyList => {
                        checkCompanyList.forEach(company => {
                            this.clickRowByChecked(company);
                        });
                    });
                });
            });
        },
        checkComanyClickFun() { //  勾选实体
            this.loadCheckCompanyData();
            
            this.checkCompanyDialogVisible = true;
        },
        async filterCheckCompanyList(userRelCompanyList) {
             //  默认table选中已勾选的公司信息
            let newCompanyList = userRelCompanyList.filter(company => {
                let checkIdList = this.checkCompanyList.map(r => r.id);
                return checkIdList.includes(company.id);
            });
            return newCompanyList;
        },
        saveCheckCompanyClickFun() {
            let checkRows = this.$refs.checkCompanyTable.selection;
            if(!checkRows || checkRows.length == 0) {
                this.$message.error('请选择需要勾选实体！');
                return;
            }
            let idList = [];
            checkRows.forEach(row => {
                idList.push(row.id);
            });
            fetchPost('/sys/main/saveUserCheckCompanyList', idList.join(',')).then(res => {
                if(res.data.success) {
                    this.$message.success('保存成功！');
                    this.checkCompanyDialogVisible = false;
                    //  更新勾选实体信息
                    this.loadCheckCompanyData();
                    //  刷新当前页面
                    location.reload();
                } else {
                    this.$message.error('保存失败：' + res.data.message);
                }
            }).catch(error => {
                this.$message.error('保存失败：' + error);
            });
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {
        // bus.$emit('collapse', this.collapse);
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
    .header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        font-size: 22px;
        color: #fff;
    }
    .collapse-btn {
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }
    .header .logo {
        float: left;
        width: 180px;
        line-height: 70px !important;
        text-align: center;
    }
    .header .logo img{
        display: inline-block;
        height: 50px;
        vertical-align: middle;
    }
    .header-right {
        float: right;
        padding-right: 50px;
    }
    .header-user-con {
        display: flex;
        height: 70px;
        align-items: center;
    }
    .btn-fullscreen {
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }
    .btn-bell,
    .btn-fullscreen {
        position: relative;
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }
    .btn-bell-badge {
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }
    .btn-bell .el-icon-bell {
        color: #fff;
    }
    .user-name {
        margin-left: 10px;
    }
    .user-avator {
        margin-left: 20px;
    }
    .user-avator img {
        display: block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .el-dropdown-link {
        color: #fff;
        cursor: pointer;
    }
    .el-dropdown-menu__item {
        text-align: center;
    }
    .el-menu--popup {
        min-width: 120px !important;
    }
    .el-badge {
        padding-right: 10px;
    }
    /deep/ .el-badge__content.is-fixed {
        top: 4px;
        right: 5px;
    }
    /deep/ .el-badge__content {
        background-color: #FF0000;
        border: none !important;
    }
    .table {
        width: 100%;
        font-size: 14px;
    }
</style>
